export default __webpack_public_path__ + "static/media/empty-approval.82980816.svg";